import apiClient from "./axiosConfig";

export const getTransfers = async (params = {}, config = {}) => {
  try {
    const response = await apiClient.get("/stock-transfer/transfers/", {
      params,
      ...config,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock transfers:", error);
    throw error;
  }
};

export const createTransfer = async (config = {}) => {
  try {
    const response = await apiClient.post("/stock-transfer/transfers/", {}, config);
    return response.data;
  } catch (error) {
    console.error("Error creating transfer:", error);
    throw error;
  }
};

export const addTransferItem = async (payload, config = {}) => {
  try {
    const response = await apiClient.post(
      "/stock-transfer/transfers/items/add-single/",
      payload,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error creating stock transfer item:", error);
    throw error;
  }
};

export const addTransferItemByTag = async (payload, config = {}) => {
  try {
    const response = await apiClient.post(
      "/stock-transfer/transfers/items/add-by-tag/",
      payload,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error adding transfer items by tag:", error);
    throw error;
  }
};
// Detail page helpers
export const getTransferSummary = async (transferId, config = {}) => {
  if (!transferId) {
    throw new Error("Transfer id is required to fetch transfer summary");
  }

  try {
    const response = await apiClient.get(
      `/stock-transfer/transfers/${transferId}/`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching stock transfer summary:", error);
    throw error;
  }
};

export const deleteTransferItem = async (itemId, config = {}) => {
  if (!itemId) {
    throw new Error("Item id is required to delete transfer item");
  }

  try {
    const response = await apiClient.delete(`/stock-transfer/items/${itemId}/`, config);
    return response.data;
  } catch (error) {
    console.error("Error deleting stock transfer item:", error);
    throw error;
  }
};

export const publishTransfer = async (transferId, config = {}) => {
  if (!transferId) {
    throw new Error("Transfer id is required to publish transfer");
  }

  try {
    const response = await apiClient.post(
      `/stock-transfer/transfers/${transferId}/publish/`,
      {},
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error publishing transfer:", error);
    throw error;
  }
};
